import React from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from './FeedItemFooter.styled';
import { Button } from '../../../atoms/Buttons';
import { AddCommentModal } from './AddCommentModal';
import { DeleteCommentModal } from './DeleteCommentModal';
import { ActivityFeedWhammyDispatchContext } from '../ActivityFeedContext';
import { Heart } from '../../../svgs';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const onSubmitLike = ({
  whammyDispatch,
  onLogin,
  member,
  likes,
  id,
  parentFeedItemId
}) => {
  try {
    if (!member) {
      if (onLogin) onLogin();
      return;
    }
    if (likes.memberHasLiked) {
      if (!likes.likeId) {
        throw new Error('likeId must be present when unliking a feed item');
      }
      if (parentFeedItemId) {
        whammyDispatch({
          type: 'UNLIKE_REPLY',
          parentFeedItemId,
          replyId: id,
          likeId: likes.likeId
        });
        return;
      }
      whammyDispatch({
        type: 'UNLIKE_FEED_ITEM',
        feedItemId: id,
        likeId: likes.likeId
      });
      return;
    }
    if (parentFeedItemId) {
      whammyDispatch({
        type: 'LIKE_REPLY',
        parentFeedItemId,
        replyId: id
      });
      return;
    }
    whammyDispatch({
      type: 'LIKE_FEED_ITEM',
      feedItemId: id
    });
  } catch (e) {
    // TODO add error handling
  }
};
export const FeedItemFooter = ({
  id,
  parentFeedItemId,
  type,
  loggedInMember,
  onLogin,
  enableLikes = false,
  likes,
  enableComments = false,
  isDeletable = false,
  // The following are only used when replying to a top-level feed item
  feedItemPreview,
  isReplyable = false,
  isLikeable = false,
  onReplySubmitted
}) => {
  const {
    t
  } = useTranslation('blocks.activityFeed');
  const whammyDispatch = React.useContext(ActivityFeedWhammyDispatchContext);
  if (!whammyDispatch) {
    throw new Error('whammyDispatch must be set');
  }
  const [isLikeButtonSubmitting, setIsLikeButtonSubmitting] = React.useState(false);
  React.useEffect(() => {
    setIsLikeButtonSubmitting(false);
  }, [likes.memberHasLiked]);
  const onClickLikeButton = () => {
    setIsLikeButtonSubmitting(true);
    onSubmitLike({
      whammyDispatch,
      member: loggedInMember,
      onLogin,
      likes,
      id,
      parentFeedItemId
    });
  };
  return /*#__PURE__*/_jsxs(Styled.Footer, {
    children: [enableLikes && isLikeable && /*#__PURE__*/_jsxs(Styled.LikeButton, {
      "data-id": "cp-activity-feed-like",
      memberHasLiked: likes.memberHasLiked,
      "aria-label": t('FeedItemFooter.likeButton.ariaLabel', {
        count: likes.count,
        defaultValue: '{{count}} likes'
      }),
      disabled: isLikeButtonSubmitting,
      onClick: onClickLikeButton,
      children: [/*#__PURE__*/_jsx(Heart, {}), likes.count]
    }), enableComments && isReplyable === true && /*#__PURE__*/_jsx(AddCommentModal, {
      feedItemId: id,
      renderTrigger: referenceProps => /*#__PURE__*/_jsx(Button.Text, {
        "data-id": "cp-activity-add-reply",
        ...referenceProps,
        children: t('FeedItemFooter.reply', 'Reply')
      }),
      feedItemPreview: feedItemPreview,
      loggedInMember: loggedInMember,
      onLogin: onLogin,
      onReplySubmitted: onReplySubmitted
    }), enableComments && isDeletable && /*#__PURE__*/_jsx(DeleteCommentModal, {
      feedItemId: id,
      parentFeedItemId: parentFeedItemId,
      feedItemType: type,
      renderTrigger: referenceProps => /*#__PURE__*/_jsx(Button.Text, {
        "data-id": "cp-activity-feed-confirm-delete",
        ...referenceProps,
        children: t('FeedItemFooter.delete', 'Delete')
      })
    })]
  });
};